import React from 'react';
import styles from '../../DataExtractionTemplate.module.scss';
import InterventionsFields from './InterventionsFields';
import CharacteristicsFields from './CharacteristicsFields';
import InterventionsPopoversList from './InterventionsPopoversList';
import { SparkleWithTooltip } from 'concepts/AutoDocExtraction/Sparkle/Sparkle';
import { Heading, Text } from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  hasExtractedData?: boolean;
  useSuggestions: boolean;
};

const InterventionsMainContent = ({
  hasExtractedData = false,
  useSuggestions,
}: Props) => {
  return (
    <>
      <Inline alignX="left" spacing={1}>
        <Heading type="h5" component="h4" variant="neutral">
          Interventions
        </Heading>
        {useSuggestions && <SparkleWithTooltip label="Interventions" />}
      </Inline>
      <InterventionsPopoversList />
      <InterventionsFields hasExtractedData={hasExtractedData} />
      <div className={styles.details} data-testid="characteristics">
        <Heading type="h5" component="h4" variant="neutral">
          Intervention details
        </Heading>
        <Text className={styles.ExtractionHeadingSubtext}>
          For each intervention reported in the study, what details do you want
          to collect?
        </Text>
        <CharacteristicsFields hasExtractedData={hasExtractedData} />
      </div>
    </>
  );
};

export default InterventionsMainContent;
